(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { gql as x, useQuery as ie, useLazyQuery as Oe, useMutation as $, isApolloError as ve } from "@apollo/client";
import { getOperationName as H } from "@apollo/client/utilities";
import { jsx as i, jsxs as f, Fragment as W } from "react/jsx-runtime";
import { FormField as B, FieldWrapper as v, Badge as q, Icon as J, FlexBox as b, Text as M, List as ne, Banner as re, Button as k, Modal as xe, ModalHead as Pe, ModalBody as We, ModalFoot as ke, Spinner as Y, Tag as Le, Tooltip as se, FieldSwitch as Re, InputSelectionList as _e, SelectionList as $e } from "@dixa/lib-shared-habla";
import { Link as Be } from "react-router-dom";
import { colors as I } from "@dixa/lib-shared-tokens";
import { useState as g, useEffect as D, createContext as ae, useContext as ce, createElement as V, useCallback as U } from "react";
import { FormProvider as Fe } from "react-hook-form";
import le from "moment";
import { useInterval as Ge } from "react-use";
import { HookFormText as Ue } from "lib-shared-hook-form";
import { MockedProvider as He } from "@apollo/client/testing";
import { render as Ke } from "@testing-library/react";
const de = x`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, ue = x`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, ge = x`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        settings {
          key
          value
        }
      }
    }
  }
`, me = x`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, Bt = (e, t) => function(n, o) {
  return ie(n, {
    ...o,
    context: {
      operationName: H(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Ft = (e, t) => function(n, o) {
  return Oe(n, {
    ...o,
    context: {
      operationName: H(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Gt = (e, t, n) => function(o, r) {
  return n.query({
    query: o,
    variables: r,
    context: {
      operationName: H(o),
      widgetId: e,
      widgetType: t
    }
  });
}, Ut = (e, t) => function(n, o) {
  return $(n, {
    ...o,
    context: {
      operationName: H(n),
      ...o?.context,
      widgetId: e,
      widgetType: t
    }
  });
}, Ht = ({
  getValueByKey: e
}) => {
  const t = e("dixaApiTokenId")?.value, n = e("dixaApiTokenName")?.value;
  return /* @__PURE__ */ i(B, { children: /* @__PURE__ */ i(v, { label: "Dixa API-Token", children: !n || !t ? /* @__PURE__ */ i(W, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ f(W, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ i(q, { variant: "secondary", size: "small", children: n }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ i(Be, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, Qe = ({
  error: e
}) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", Kt = ({
  errors: e
}) => e.some((t) => Qe({ error: t })), Ve = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", Qt = ({
  errors: e
}) => e.some((t) => Ve({ error: t })), ze = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", Vt = ({
  errors: e
}) => e.some((t) => ze({ error: t })), qe = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", zt = ({
  errors: e
}) => e.some((t) => qe({ error: t })), Je = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", qt = ({
  errors: e
}) => e.some((t) => Je({ error: t })), Ye = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", Jt = ({
  errors: e
}) => e.some((t) => Ye({ error: t })), Ze = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", Yt = ({
  errors: e
}) => e.some((t) => Ze({ error: t })), je = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", Zt = ({
  errors: e
}) => e.some((t) => je({ error: t })), Xe = ({
  error: e
}) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", jt = ({
  errors: e
}) => e.some((t) => Xe({ error: t })), et = ({
  error: e
}) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", tt = ({
  errors: e
}) => e.some((t) => et({ error: t })), nt = (e) => {
  const { delay: t = 2e3 } = e || {}, [n, o] = g(!1);
  return D(() => {
    const s = n ? window.setTimeout(() => o(!1), t) : void 0;
    return () => window.clearTimeout(s);
  }, [t, n]), { isCopied: n, copy: (s) => {
    navigator.clipboard.writeText(s), o(!0);
  } };
}, ot = "_errorWrapper_171rr_1", it = "_copyIcon_171rr_5", z = {
  errorWrapper: ot,
  copyIcon: it
}, fe = ({
  error: e,
  retry: t,
  isMisconfigured: n = !1
}) => {
  const r = e && ve(e) && e?.graphQLErrors?.length > 0, { isCopied: s, copy: a } = nt(), u = /* @__PURE__ */ i(
    J,
    {
      color: I.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (n || r && tt({
    errors: e.graphQLErrors
  }))
    return /* @__PURE__ */ f(b, { margin: "0 0 100", padding: "200", className: z.errorWrapper, children: [
      /* @__PURE__ */ i(b, { margin: "0 300 0 0", alignItems: "center", children: u }),
      /* @__PURE__ */ i(M.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!r)
    return /* @__PURE__ */ i(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ i(
      ne.Item,
      {
        contentLeft: u,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const d = e?.graphQLErrors || [];
  return /* @__PURE__ */ f(
    b,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: z.errorWrapper,
      children: [
        d.map((h, c) => {
          const m = h?.extensions?.integration, w = m?.message || e?.message || "No error message available", p = m?.responseBody && JSON.parse(m?.responseBody), C = p?.errorMessages || [], y = p?.warningMessages || [], A = [...C, ...y].join(" ");
          return /* @__PURE__ */ i(
            ne.Item,
            {
              title: w,
              titleSecondary: A,
              contentLeft: u
            },
            c
          );
        }),
        /* @__PURE__ */ f(b, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ i(
            re,
            {
              variant: "info",
              description: /* @__PURE__ */ i(M.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ f(b, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ i(k, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ i(
              k,
              {
                variant: "secondary",
                icon: s ? "done" : "copy",
                onClick: () => a(JSON.stringify(d, null, 2)),
                className: z.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
}, rt = ({
  headline: e,
  text: t,
  children: n,
  onConfirm: o,
  onCancel: r,
  confirmLabel: s,
  cancelLabel: a = "Cancel",
  confirmVariant: u = "primary",
  cancelVariant: d = "secondary",
  isOpen: h,
  setIsOpen: c,
  showOnClose: m = !1
}) => /* @__PURE__ */ f(
  xe,
  {
    isOpen: h,
    onClose: () => {
      r && r(), c(!1);
    },
    children: [
      /* @__PURE__ */ i(
        Pe,
        {
          title: e,
          onClose: m ? r : void 0
        }
      ),
      /* @__PURE__ */ f(We, { children: [
        t && /* @__PURE__ */ i("div", { style: { width: "600px" }, children: t }),
        n
      ] }),
      /* @__PURE__ */ i(
        ke,
        {
          confirmOnClick: o ? () => {
            o(), c(!1);
          } : void 0,
          cancelOnClick: () => {
            r && r(), c(!1);
          },
          confirmName: s,
          cancelName: a,
          confirmProps: { variant: u },
          cancelProps: { variant: d }
        }
      )
    ]
  }
), Z = "The configuration of the integration is not correct. Please check the settings.", Xt = ({
  cause: e
}) => /* @__PURE__ */ i(b, { margin: "0 0 400", children: /* @__PURE__ */ i(
  re,
  {
    variant: "fail",
    headline: "This integration is misconfigured",
    description: /* @__PURE__ */ f(b, { gap: "300", flexDirection: "column", children: [
      /* @__PURE__ */ i(M.Paragraph, { children: e || Z }),
      /* @__PURE__ */ f(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ i(M.Heading, { variant: "heading-3", children: "Additional information" }),
        /* @__PURE__ */ i(M.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
      ] })
    ] })
  }
) }), en = ({
  form: e,
  integrationId: t,
  onValidSubmit: n,
  error: o,
  onRetry: r,
  isLoading: s,
  isWidgetUnknown: a,
  children: u
}) => o ? /* @__PURE__ */ i(fe, { error: o, retry: r }) : s ? /* @__PURE__ */ i(Y, { "data-testid": "widget-settings-loading" }) : a ? /* @__PURE__ */ f(M.Paragraph, { children: [
  "A widget with the id ",
  /* @__PURE__ */ i(Le, { children: t }),
  " does not exist."
] }) : /* @__PURE__ */ i(Fe, { ...e, children: /* @__PURE__ */ i(
  "form",
  {
    noValidate: !0,
    tabIndex: -1,
    "data-testid": `widget-settings-form-${t ?? "create-new"}`,
    onSubmit: e.handleSubmit(n),
    children: u
  }
) });
function tn(e, t = !0) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const nn = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, he = "DD MMM YYYY @ HH:mm";
function st(e, t) {
  return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function at(e, t) {
  return e == null ? t : String(e);
}
function on(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const rn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], sn = (e) => {
  if (!e?.trim())
    return "Please add a valid subdomain";
  const n = ["https://", "http://"].find(
    (s) => e.startsWith(s)
  ), o = n ? `Please remove the protocol \`${n}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (o && r)
    return `Please remove the protocol \`${n}\` and the trailing \`/\` from the hostname`;
  if (o)
    return o;
  if (r)
    return r;
};
function ct(e) {
  const t = e.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const n = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(n).toString());
  } catch (o) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${o}`
    );
  }
}
const pe = ae(null), lt = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pe.Provider
);
function Ce() {
  const e = ce(pe);
  if (e === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return e;
}
const dt = {
  useMutation: $,
  useQuery: () => {
  },
  useLazyQuery: () => {
  },
  executeQuery: () => {
  },
  showNotification: () => {
  },
  showModal: () => {
  }
}, ut = {
  baseUrl: "http://localhost/graphql"
};
function an(e, { mocks: t = [], overrides: n = {} } = {}) {
  const o = vi.fn(), r = vi.fn(), a = { ...{
    configuration: ut,
    handleRedirect: o,
    showNotification: r
  }, ...n };
  return { ...Ke(
    V(
      He,
      { mocks: t },
      V(
        lt,
        { value: dt },
        V(e, a)
      )
    )
  ), handleRedirect: o, showNotification: r };
}
function cn({
  id: e,
  configuration: t
}) {
  const n = t?.settings ?? [];
  return {
    request: {
      query: de,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          widgetConfigurations: [
            {
              id: e,
              type: t?.type ?? "UNKNOWN",
              name: t?.name ?? "Test widget",
              enabled: t?.enabled ?? !0,
              misconfigured: t?.misconfigured ?? !1,
              misconfigurationCause: t?.misconfigurationCause ?? null,
              additionalProperties: t?.additionalProperties ?? null,
              settings: n
            }
          ]
        }
      }
    }
  };
}
function ln({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: ge,
      variables: e
    },
    result: {
      data: {
        Management: {
          createWidgetConfiguration: {
            id: t?.id ?? "new-id",
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function dn({
  variables: e,
  result: t
}) {
  return {
    request: {
      query: ue,
      variables: e
    },
    result: {
      data: {
        Management: {
          updateWidgetConfiguration: {
            id: e.id,
            name: t?.name ?? e.name,
            enabled: t?.enabled ?? e.enabled ?? !0,
            misconfigured: t?.misconfigured ?? !1,
            misconfigurationCause: t?.misconfigurationCause ?? null,
            additionalProperties: t?.additionalProperties ?? null,
            settings: t?.settings ?? []
          }
        }
      }
    }
  };
}
function un({
  id: e
}) {
  return {
    request: {
      query: me,
      variables: { id: e }
    },
    result: {
      data: {
        Management: {
          deleteWidgetConfiguration: { id: e }
        }
      }
    }
  };
}
function gt(e, t) {
  const n = {};
  for (const o of t) {
    const s = e.find((a) => a.key === o.key)?.value;
    o.secret && s === void 0 || (o.type === "boolean" ? n[o.key] = st(s, o.defaultValue) : n[o.key] = at(s, o.defaultValue));
  }
  return n;
}
function mt(e, t) {
  return t.filter((n) => e[n.key] !== void 0).map((n) => ({
    key: n.key,
    value: String(e[n.key]),
    secret: n.secret
  }));
}
async function gn(e, {
  fieldDefinitions: t,
  isCreationMode: n,
  create: o,
  update: r
}) {
  const s = mt(e, t), a = {
    name: e.name,
    enabled: e.enabled,
    settings: s
  };
  n ? await o(a) : await r(a);
}
function ft(e) {
  const { user_id: t, iss: n } = ct(e);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": n
  };
}
function ht(e) {
  return e.startsWith("http://localhost");
}
const pt = ae(null);
function Ct() {
  const e = ce(pt);
  if (e === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return e;
}
function mn() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function j() {
  return { track: (t, n) => window._partner.events.emit(t, n) };
}
const yt = (e) => {
  switch (e) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: I.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: I.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: I.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: I.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: I.neutral[500],
        tooltip: "Not connected"
      };
  }
}, fn = ({
  configuration: e,
  integrationId: t,
  integrationType: n,
  label: o
}) => {
  const [r, s] = g("CONNECTING"), [a, u] = g(""), [d, h] = g(null), { track: c } = j(), { icon: m, color: w, tooltip: p } = yt(r), C = 3, y = 15, A = 2e3, [l, N] = g({}), [S, P] = g(0), [L, O] = g(A), [ye, K] = g(!1), [Ee, we] = g(C), {
    isInboundOAuth: Ae,
    setIsInboundOAuth: be,
    hasTriggeredAuthorization: Ne,
    setHasTriggeredAuthorization: Se
  } = Ct(), { baseUrl: F } = e, De = `${F}/auth/connect/${n.toLowerCase()}/${t}`, Me = `${F}/auth/status/${n.toLowerCase()}/${t}`, X = r === "CONNECTING", ee = (E) => Object.keys(E).length === 0, Q = () => {
    K(!1), P(0);
  };
  D(() => {
    const E = localStorage.getItem("authData");
    if (E) {
      const T = JSON.parse(E ?? "{}").access_token;
      N({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${T}`,
          ...ht(F) && ft(T)
        }
      });
    }
  }, [F]), D(() => {
    ee(l) || K(!0);
  }, [l]);
  const Te = () => {
    we(y), fetch(Me, { ...l }).then((E) => E.json()).then(({ data: E }) => {
      const { status: R, createdAt: T, createdByName: _ } = E;
      switch (R) {
        case "CONNECTING":
          s("CONNECTING");
          break;
        case "CONNECTED": {
          if (c("settings:view:oauth:succeeded", {
            widgetId: t,
            widgetType: n
          }), s("CONNECTED"), T && _) {
            const G = new Date(T);
            isNaN(G.getTime()) || h(G), u(_);
          }
          Q();
          break;
        }
        case "NOT_CONNECTED":
        case "CONNECTION_FAILED":
          s(R), Q();
      }
    }).catch((E) => {
      console.warn(
        `Fetching OAuth status failed for ${n} ${t}`,
        E
      ), s("CONNECTION_FAILED");
    });
  };
  Ge(
    () => {
      S >= Ee ? (s("CONNECTION_TIMEOUT"), Q()) : (Te(), P(S + 1));
    },
    ye ? L : null
  );
  const te = () => {
    c("settings:view:oauth:started", {
      widgetId: t,
      widgetType: n
    }), fetch(De, { ...l }).then((E) => E.json()).then(({ data: E }) => {
      const { url: R } = E, T = 620, _ = 800, G = window.innerWidth / 2 - T / 2, Ie = window.innerHeight / 2 - _ / 2;
      s("CONNECTING"), K(!0), window.open(
        R,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${T},
						height=${_},
						left=${G},
						top=${Ie}`
      );
    }).catch((E) => {
      console.warn(
        `Fetching OAuth connection failed for ${n} ${t}`,
        E
      ), s("CONNECTION_FAILED");
    });
  };
  return D(() => {
    Ae && !Ne && !ee(l) && (Se(!0), be(!1), te());
  }, [l]), /* @__PURE__ */ f(W, { children: [
    /* @__PURE__ */ i(B, { span: 3, children: /* @__PURE__ */ i(
      v,
      {
        label: o,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ f(b, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ i(
            k,
            {
              icon: "key",
              variant: "secondary",
              onClick: te,
              disabled: X,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ i(se, { content: p, children: X ? /* @__PURE__ */ i(Y, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ f(b, { alignItems: "center", gap: "200", children: [
            /* @__PURE__ */ i(
              J,
              {
                "data-testid": "oauth-button-status-icon",
                name: m,
                color: w
              }
            ),
            r === "CONNECTED" && a && d && /* @__PURE__ */ f(M.Paragraph, { variant: "4", subdued: !0, children: [
              "Authorized by ",
              a,
              " at",
              " ",
              le(d).format(he)
            ] })
          ] }) })
        ] })
      }
    ) }),
    /* @__PURE__ */ i(B, { span: 3 })
  ] });
}, Et = "_settingsWrapper_eleyu_1", wt = {
  settingsWrapper: Et
}, At = x`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, oe = [], hn = ({
  settings: e,
  getValueByKey: t,
  handleChangeSelect: n
}) => {
  const o = "subscriptionListId", s = e?.find(
    (l) => l.key === o
  )?.label ?? "Activate re-/subscription list selection", a = t(o)?.value, { useQuery: u } = Ce(), [d, h] = g(oe), [c, m] = g(!!a), [w, p] = g(a), {
    data: C,
    error: y,
    loading: A
  } = u(At, {
    skip: !c,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return D(() => {
    a && (p(a), m(!0));
  }, [a]), D(() => {
    const l = C?.Klaviyo?.get_lists;
    if (c && l && !A && !y) {
      const N = l?.data?.map(
        (S) => ({
          value: S?.id,
          label: S?.attributes?.name
        })
      ) || oe;
      h(N);
    }
  }, [c, C, A, y]), /* @__PURE__ */ f(W, { children: [
    /* @__PURE__ */ i(B, { span: 3, children: /* @__PURE__ */ f(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: wt.settingsWrapper,
        children: [
          /* @__PURE__ */ i(v, { label: s, children: /* @__PURE__ */ i(
            Re,
            {
              input: {
                name: `${o}-switch`,
                value: "switchValueFromComponent",
                checked: c,
                onChange: () => {
                  const l = !c;
                  l || n(o, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), m(l);
                }
              }
            }
          ) }),
          c && y && !A && /* @__PURE__ */ i(v, { children: /* @__PURE__ */ i(fe, { error: y }) }),
          c && !y && A && /* @__PURE__ */ i(v, { children: /* @__PURE__ */ i(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ i(Y, {}) }) }),
          c && !y && !A && d && /* @__PURE__ */ i(v, { label: "Available lists to subscribe to", children: /* @__PURE__ */ i(
            _e,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (l) => {
                n(o, l), p(l?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (l) => l ? /* @__PURE__ */ i(M.Paragraph, { children: l.label }) : null,
              value: w ? [
                {
                  label: (d || []).find(
                    (l) => l.value === w
                  )?.label,
                  value: w
                }
              ] : [],
              equalityFn: (l, N) => l.value === N.value,
              children: d.map((l) => /* @__PURE__ */ i($e.Item, { value: l, children: l.label }, l.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ i(B, { span: 3 })
  ] });
}, pn = (e) => {
  if (e == null)
    return null;
  if (typeof e == "boolean" || e === "true" || e === "false") {
    const o = e === "true" || e === !0;
    return /* @__PURE__ */ i(
      J,
      {
        name: o ? "check-circle-filled" : "close-circle-filled",
        color: o ? I.green[500] : I.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${o ? "true" : "false"}`
      }
    );
  }
  if (typeof e == "number" || /^\d*\.?\d+$/.test(e))
    return /* @__PURE__ */ i(q, { variant: "success", size: "small", children: e });
  if (e.startsWith("days_ago: ")) {
    const o = e.replace("days_ago: ", ""), r = o.startsWith("-"), s = o === "0", a = r ? `${o.replace("-", "")} days ago` : `in ${o} days`;
    return /* @__PURE__ */ i(M.Paragraph, { variant: "5", color: "secondary", children: s ? "today" : a });
  }
  const n = le(e);
  return n.isValid() ? /* @__PURE__ */ i(M.Paragraph, { variant: "5", color: "secondary", children: n.format(he) }) : /* @__PURE__ */ i(q, { variant: "info", size: "small", children: e });
}, Cn = (e) => {
  const { isCreationMode: t = !1, label: n, helpIcon: o, name: r } = e, [s, a] = g(t);
  if (!s) {
    const u = typeof n == "string" ? n : "";
    return /* @__PURE__ */ i(v, { label: n, helpIcon: o, children: /* @__PURE__ */ f(
      k,
      {
        "data-testid": `secret-field-button-${r}`,
        variant: "secondary",
        icon: "pen",
        onClick: () => a(!0),
        children: [
          "Update ",
          u
        ]
      }
    ) });
  }
  return /* @__PURE__ */ i(
    bt,
    {
      ...e,
      isCreationMode: t,
      onClose: () => a(!1)
    }
  );
}, bt = (e) => {
  const { isCreationMode: t, componentProps: n, onClose: o } = e, r = {
    ...n,
    prefix: t ? n?.prefix : {
      type: "button",
      button: { icon: "close", onClick: o }
    }
  };
  return /* @__PURE__ */ i(
    Ue,
    {
      ...e,
      componentProps: r,
      shouldUnregister: !0
    }
  );
}, Nt = {
  submit: "Submit",
  delete: "Delete",
  confirmDelete: "Yes",
  cancelDelete: "No"
}, yn = ({
  integrationType: e,
  integrationId: t,
  widgetName: n,
  isCreationMode: o,
  isSubmitting: r,
  automationCouplingState: s,
  onConfirmDelete: a,
  labels: u,
  deleteConfirmationBody: d,
  confirmDeleteVariant: h = "primary"
}) => {
  const { track: c } = j(), [m, w] = g(!1), p = { ...Nt, ...u }, C = !s || !s.isCoupled, y = () => {
    t && c("settings:view:delete:requested", {
      widgetId: t,
      widgetType: e
    }), w(!0);
  }, A = () => {
    t && c("settings:view:delete:canceled", {
      widgetId: t,
      widgetType: e
    });
  };
  return /* @__PURE__ */ f(W, { children: [
    /* @__PURE__ */ f(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ i(k, { type: "submit", isLoading: r, disabled: r, children: p.submit }),
      !o && /* @__PURE__ */ i(
        se,
        {
          content: "The widget is used in automations",
          disabled: C,
          children: /* @__PURE__ */ i(
            k,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              type: "button",
              onClick: y,
              disabled: !C,
              isLoading: s?.isLoading,
              children: p.delete
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ i(
      rt,
      {
        isOpen: m,
        setIsOpen: w,
        confirmVariant: h,
        confirmLabel: p.confirmDelete,
        cancelLabel: p.cancelDelete,
        onCancel: A,
        onConfirm: a,
        children: /* @__PURE__ */ i(b, { children: d ?? /* @__PURE__ */ f(W, { children: [
          "Are you sure you want to delete the ",
          e,
          ' integration "',
          n,
          '"?'
        ] }) })
      }
    )
  ] });
}, St = x`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Dt = x`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function En(e) {
  const { useQuery: t, useMutation: n } = Ce(), [o, r] = g(), [s, a] = g(), [u, d] = g(!1), {
    loading: h,
    data: c,
    error: m
  } = t(
    St,
    {
      skip: !e,
      variables: {
        conversationId: e?.toString()
      }
    }
  ), [w, { loading: p, error: C }] = n(
    Dt
  ), y = async (A, l) => await w({
    variables: {
      conversationId: (l ?? e)?.toString(),
      data: A
    }
  }).then(
    ({ data: S }) => r(S?.Storage?.storeWidgetData?.data ?? {})
  );
  return D(() => {
    !h && c && r(c?.Storage?.widgetData ?? {});
  }, [c, h]), D(() => m && a(m), [m]), D(() => d(h), [h]), D(() => C && a(C), [C]), D(() => d(p), [p]), {
    data: o,
    loading: u,
    store: y,
    error: s
  };
}
const wn = ({
  integrationId: e,
  integrationType: t,
  handleRedirect: n,
  showNotification: o
}) => {
  const { track: r } = j(), [s, a] = g(!1), [u, d] = g(), [h, c] = g(null), m = U(
    (N) => (S) => {
      d(S), a(!1), o({
        title: "Something went wrong",
        text: `The ${N} of the widget was not successful.`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    [o]
  ), [w] = $(ge, {
    onError: m("creation")
  }), [p] = $(ue, {
    onError: m("update")
  }), [C] = $(me, {
    onError: m("deletion")
  }), y = U(
    async ({ name: N, enabled: S, settings: P }) => {
      r("settings:create:submitted", { widgetType: t }), a(!0), d(void 0);
      const { data: L } = await w({
        variables: { type: t, name: N, enabled: S, settings: P }
      });
      a(!1);
      const O = L?.Management?.createWidgetConfiguration;
      if (!O) {
        o({
          title: "Something went wrong",
          text: "The creation of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      o({
        title: "Creating was successful",
        text: "Creating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), n(O.id);
    },
    [w, n, t, o, r]
  ), A = U(
    async ({ name: N, enabled: S, settings: P }) => {
      if (!e)
        return;
      r("settings:view:change:submitted", {
        widgetId: e,
        widgetType: t
      }), a(!0), d(void 0);
      const { data: L } = await p({
        variables: { id: e, name: N, enabled: S, settings: P }
      });
      a(!1);
      const O = L?.Management?.updateWidgetConfiguration;
      if (!O) {
        o({
          title: "Something went wrong",
          text: "The update of the widget was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
        return;
      }
      O.misconfigured ? c(
        O.misconfigurationCause ?? Z
      ) : c(null), o({
        title: "Updating was successful",
        text: "Updating the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    },
    [e, t, o, r, p]
  ), l = U(async () => {
    if (!e)
      return;
    r("settings:view:delete:confirmed", {
      widgetId: e,
      widgetType: t
    }), a(!0), d(void 0);
    const { data: N } = await C({
      variables: { id: e }
    });
    a(!1), N?.Management?.deleteWidgetConfiguration && (n(), o({
      title: "Deletion was successful",
      text: "The deletion of the widget was successful.",
      icon: "check-circle-filled",
      severity: "success"
    }));
  }, [
    C,
    n,
    e,
    t,
    o,
    r
  ]);
  return {
    create: y,
    update: A,
    remove: l,
    isLoading: s,
    error: u,
    misconfigurationCause: h,
    setMisconfigurationCause: c
  };
};
function An({
  integrationId: e,
  fieldDefinitions: t,
  form: n,
  onMisconfigured: o
}) {
  const [r, s] = g(!1), { loading: a, error: u, refetch: d } = ie(de, {
    variables: { id: e },
    skip: !e,
    onCompleted: (h) => {
      const c = h?.Management?.widgetConfigurations?.[0];
      if (!c) {
        s(!0);
        return;
      }
      s(!1), n.reset({
        ...gt(c.settings ?? [], t),
        enabled: !!c.enabled,
        name: c.name
      }), c.misconfigured && o?.(
        c.misconfigurationCause ?? Z
      );
    }
  });
  return D(() => {
    e || s(!1);
  }, [e]), {
    isLoading: a,
    error: u,
    isWidgetUnknown: r,
    refetch: d
  };
}
export {
  fe as DisplayErrors,
  Ht as DixaApiTokenSettings,
  pt as InboundOAuthContext,
  rt as IntegrationModal,
  hn as KlaviyoSubscribeSetting,
  Xt as MisconfigurationBanner,
  fn as OAuthSettings,
  Cn as PartnerHookFormSecretText,
  en as PartnerSettingsWrapper,
  lt as WidgetContextProvider,
  yn as WidgetSettingsFormFooter,
  nn as capitalizeFirstCharacter,
  rn as countryCodes,
  mn as createMockInboundOAuthContextOptions,
  ln as createWidgetConfigurationCreateMock,
  un as createWidgetConfigurationDeleteMock,
  ge as createWidgetConfigurationMutation,
  cn as createWidgetConfigurationQueryMock,
  dn as createWidgetConfigurationUpdateMock,
  tn as deepClone,
  he as defaultDateFormat,
  Z as defaultMisconfigurationCause,
  ut as defaultPartnerSettingsConfiguration,
  dt as defaultWidgetContextValue,
  me as deleteWidgetConfigurationMutation,
  pn as displayAttributeValue,
  mt as formValuesToSettings,
  yt as getConnectionStatusValues,
  on as getCountryNameFromCountryCode,
  At as getListsQuery,
  ft as getPartnerDevApiHeaders,
  de as getWidgetConfigurationByIdQuery,
  gn as handleWidgetSubmit,
  Kt as hasDixaHeaderCheckError,
  Qt as hasDownstreamApiAuthorizationError,
  Yt as hasDownstreamApiBadRequestError,
  Jt as hasDownstreamApiConflictError,
  Zt as hasDownstreamApiForbiddenError,
  qt as hasDownstreamApiNotFoundError,
  Vt as hasDownstreamApiPermissionError,
  zt as hasDownstreamApiServiceUnavailableError,
  jt as hasDownstreamApiTooManyRequestsError,
  tt as hasWidgetMisconfiguredError,
  Qe as isDixaHeaderCheckError,
  Ve as isDownstreamApiAuthorizationError,
  Ze as isDownstreamApiBadRequestError,
  Ye as isDownstreamApiConflictError,
  je as isDownstreamApiForbiddenError,
  Je as isDownstreamApiNotFoundError,
  ze as isDownstreamApiPermissionError,
  qe as isDownstreamApiServiceUnavailableError,
  Xe as isDownstreamApiTooManyRequestsError,
  ht as isRunningLocalPartnerApi,
  et as isWidgetMisconfiguredError,
  Gt as makeExecuteQuery,
  Ft as makeUseLazyQuery,
  Ut as makeUseMutation,
  Bt as makeUseQuery,
  ct as parseAccessToken,
  st as parseBoolean,
  at as parseString,
  an as renderPartnerSettings,
  gt as settingsToFormValues,
  ue as updateWidgetConfigurationMutation,
  nt as useCopyWithDelay,
  En as useData,
  Ct as useInboundOAuthContext,
  j as useTracking,
  Ce as useWidgetContext,
  wn as useWidgetSettingsMutations,
  An as useWidgetSettingsQuery,
  sn as validateApiHostName
};
